// src/components/decorations/ColdcardNoticeBanner.jsx
import { Flex, Text, Link, useColorMode } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ColdcardNoticeBanner = () => {
  const { colorMode } = useColorMode();

  return (
    <Flex
      bg={colorMode === 'dark' ? 'red.600' : 'red.500'}
      color="white"
      px={{ base: '10px', md: '20px' }}
      py="8px"
      align="center"
      gap="10px"
    >
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="semibold" flex="1">
        <Text as="span" fontWeight="extrabold" bg="yellow.300" color="black" px="4px" borderRadius="2px">FUNDS ARE AT RISK!</Text> Coinkite has disclosed a seed generation flaw affecting Coldcard MK3/MK4/MK5/Q devices.{' '}
        <Link
          href="https://blog.coinkite.com/coldcard-mk3-seed-generation-warning/"
          isExternal
          textDecoration="underline"
          fontWeight="bold"
        >
          Read the official notice NOW
        </Link>
      </Text>
    </Flex>
  );
};
